import React, { Component } from 'react';
import { Tree, Card } from 'antd';

const { TreeNode } = Tree;
class TreeOrg extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [
        {
          title: '财务流程',
          key: 'finance',
          children: [
            { title: '报销申请', key: 'expenses' },
            { title: '付款申请', key: 'payment' },
            { title: '借款申请', key: 'loan' },
            { title: '开票申请', key: 'FinInvoice' },
          ],
        },
        {
          title: '行政流程',
          key: 'administraive',
          children: [
            { title: '用章申请', key: 'seal' },
            { title: '采购申请', key: 'purchase' },
            { title: '资料借用', key: 'matBorrow' },
          ],
        },
        {
          title: '人事流程',
          key: 'hr',
          children: [
            { title: '工资申请', key: 'wage' },
            { title: '年终奖申请', key: 'bonus' },
          ],
        },
        {
          title: '孵化器业务',
          key: 'incubator',
          children: [
            { title: '入驻申请', key: 'enter' },
            { title: '退款申请', key: 'back' },
            { title: '开票申请', key: 'incuInvoice' },
            { title: '注册申请', key: 'register' },
            { title: '错款退还', key: 'refund' },
            { title: '作废发票', key: 'invalid' },
          ],
        },
      ],
    };
  }

  renderTreeNodes = data => {
    return data.map(item => {
      if (item.children) {
        return (
          <TreeNode title={item.title} key={item.key}>
            {this.renderTreeNodes(item.children)}
          </TreeNode>
        );
      }
      return <TreeNode key={item.key} {...item} />;
    });
  };

  render() {
    const { list } = this.state;
    return (
      <Card>
        <a>全部</a>
        <Tree defaultExpandAll onSelect={this.props.onSelect} showLine>
          {this.renderTreeNodes(list)}
        </Tree>
      </Card>
    );
  }
}

export default TreeOrg;



// WEBPACK FOOTER //
// ./src/components/flow/TreeOrg.js